import type ChartJs from 'chart.js'

interface IProps {
  readonly height?: number
  readonly width?: number
  readonly options: ChartJs.ChartConfiguration
}

/**
 * A ChartJs fölött egy példányosító, wrapper komponens.
 *
 * Ez csak egy wrapper fölötte, a ChartJS lib betöltése minden project saját felelőssége.
 * Ne is refaktoráld úgy ezt a függvényt, hogy megcsinálja, mert az adott projectben törést okozhat!
 *
 * @see {@link https://www.chartjs.org/}
 * @param props - A ChartJs lehetséges beállításai.
 */
export default function Chart (props: IProps): HTMLDivElement {
  const el = document.createElement('div')

  if (props.width && props.height) {
    el.style.width  = `${ props.width }px`
    el.style.height = `${ props.width }px`
  }

  const canvas = document.createElement('canvas')
  el.appendChild(canvas)

  // @ts-expect-error Példányosítás.
  const _chart = new window.Chart(canvas, props.options)

  return el
}
